export default "__VITE_ASSET__BbMFqc94__"